import { Component, OnInit } from '@angular/core';
import { ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ModalService } from 'src/app/shared/services/modal.service';
import { ApiService } from 'src/app/shared/services/api.service';
import { UtilsService } from 'src/app/shared/services/utils.service';

import { data, introSlider, slides } from '../data';
import { SearchService } from '../../../shared/services/search.service';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { faqGroups } from './faq-data';
import { filterData } from '../../products/shared/data';
import { User } from '../../../shared/classes/app.models';
import { AuthenticationService } from '../../../shared/services/authentication.service';
import { masterData } from '../../products/media-detail/image-price';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { EULA_NANO } from './eula-nano';
import { EULA_NUR } from './eula-nur';
import { AiStatusService } from 'src/app/shared/services/ai-status.service';
import { Router } from '@angular/router';


@Component({
    selector: 'indiapicture-ai',
    templateUrl: './ai.component.html',
    styleUrls: ['./ai.component.scss']
})

export class AiComponent implements OnInit, AfterViewInit {


    @ViewChild('maskCanvas') maskCanvasRef!: ElementRef<HTMLCanvasElement>;

    isObjectRemovalMode: boolean = false;

    private ctx!: CanvasRenderingContext2D;
    private drawing = false;

    brushSize: number = 30;



    uuid: any = '';
    status: string = '';
    private pollingInterval = null;
    private destroy$ = new Subject<void>();
    usageType = masterData.usage[0]['creative'];
    usageSelected: string = '';
    btn: number = 0;
    selectedIndex = -1;
    selectedRecentIndex = -1;
    image: any;
    cartProduct: any;
    disableBtn = false;
    isPackageExpired = false;
    editedImage:any;

    scale = 1;
    maxScale = 4;
    minScale = 1;

    posX = 0;
    posY = 0;

    isDragging = false;
    startX = 0;
    startY = 0;


    // Checkbox states
    isPersonalUseChecked: boolean = false;
    isCommercialUseChecked: boolean = false;

    // Dynamic button text
    downloadButtonLabel: string = 'Select an option';
    recentHistory: any = [];

    // selectedModel: string = 'nur_ai';

    selectedModel: string = 'banana';
    selectedModelLabel: string = 'Nano Banana';


    showPlanPopup = false;
    attachedImage: File | null = null;


    // default model
    models = [
        { label: 'Nano Banana', value: 'banana' },
        { label: 'IP Gen', value: 'nur_ai' }
    ];

    currentEulaHtml: string = '';


    constructor(public apiService: ApiService, public utilsService: UtilsService,
        private modalService: ModalService, private searchService: SearchService,
        private toastService: ToastrService, private fb: FormBuilder, 
        private authService: AuthenticationService, 
        private sanitizer: DomSanitizer, 
        private aiStatusService: AiStatusService,
    private router: Router) {

        this.authService.currentUser.subscribe((x:any) => {
            // console.log('currentUser in AI ', x);
            this.currentUser = x;
            if (x && (x as any).customers_id && x.isExclusive == true) {
                this.loadAiPermissions();
            } else {
                // this.resetAiPermissions();
                this.showAllAiPermissions();
            }
        });

        this.searchService = SearchService.getInstance();
        this.searchService.setSearch('');
        this.searchService.setCategory('creative');

        this.form = this.fb.group({
            prompt: ['', Validators.required],
            intendedUse: [''],
            name: ['', Validators.required],
            companyName: ['', Validators.required],
            email: ['', [Validators.required, Validators.email]],
            number: ['', Validators.required],
            image_dimensions: ['', Validators.required],
            uploadedImages: [[]],
            imageLinks: this.fb.array([
                this.fb.control(''),
                this.fb.control('')
            ])
        });
        this.usageSelected = this.usageType[0].id;

    }
    ngAfterViewInit(): void {
        // throw new Error('Method not implemented.');
    }


    get imageLinks(): FormArray {
        return this.form.get('imageLinks') as FormArray;
    }

    public faqs = faqGroups;
    form: FormGroup;
    products = [];
    posts = [];
    loaded = false;
    productLoaded = false;
    introSlider = introSlider;
    setting: any;
    slides = slides;
    banners = [];
    isMobile = false;
    imagePreviews: string[] = [];
    promptText = '';
    selectedAspect = '16:9';
    selectedAspectSlug = '';
    selectedStyle = 'Auto';
    currentUser: any;
    generateButtonClick = false;
    selectedFiles: File[] = [];

    aiPermissionsLoaded = false;
    aiPermissions: any[] = [];
    canGenerateImage = false;

    // 2 = exclusive sub-user account, 1 = regular customer. Sent on every AI request.
    get customerFrom(): number {
        return (this.currentUser as any)?.isExclusive === true ? 2 : 1;
    }
    toolPermissions: { [key: string]: boolean } = {
        background_removal: false,
        style_transfer: false,
        image_upscale: false,
        object_removal: false,
        semantic_masking: false,
    };
    private readonly toolLabels: { [key: string]: string } = {
        background_removal: 'Background Removal',
        style_transfer: 'Style Transfer',
        upscale_4k: 'Image Upscale',
        object_removal: 'Object Removal',
        semantic_masking: 'Semantic Masking',
    };

    protected readonly faqGroups = faqGroups;

    showModal(event: Event) {
        event.preventDefault();
        this.modalService.showVideoModal();
    }

    ngOnInit(): void {

        if (window.innerWidth <= 500) {
            this.isMobile = true;
        }

        this.getRecentImagesGenerated();
    }

    onFilesChange(event: any): void {
        const files: FileList = event.target.files;

        if (!files || files.length === 0) {
            return;
        }

        const validImageTypes = ['image/jpeg', 'image/png', 'image/webp', 'image/gif'];

        // Convert FileList to Array and filter valid images
        const selected = Array.from(files).filter(file =>
            validImageTypes.includes(file.type)
        );

        if (selected.length === 0) {
            alert('Please upload only image files (jpg, png, gif, webp)');
            return;
        }

        if (selected.length > 5) {
            alert('You can upload a maximum of 5 images');
            this.selectedFiles = selected.slice(0, 5);
        } else {
            this.selectedFiles = selected;
        }

        this.imagePreviews = [];

        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            const reader = new FileReader();
            reader.onload = (e: any) => {
                this.imagePreviews.push(e.target.result);
            };
            reader.readAsDataURL(file);
        }

        // console.log('Selected Files:', this.selectedFiles);
    }

    onSubmit(): void {
        if (this.form.valid) {
            const formData = new FormData();
            formData.append('prompt', this.form.get('prompt')?.value);
            formData.append('intendedUse', this.form.get('intendedUse')?.value);
            formData.append('name', this.form.get('name')?.value);
            formData.append('companyName', this.form.get('companyName')?.value || '');
            formData.append('email', this.form.get('email')?.value);
            formData.append('number', this.form.get('number')?.value);
            formData.append('image_dimensions', this.form.get('image_dimensions')?.value);

            // Add up to 2 links
            const links = this.form.get('imageLinks')?.value || [];
            links.forEach((link: string, index: number) => {
                if (link) {
                    formData.append(`imageLinks[${index}]`, link);
                }
            });

            // Add up to 5 images
            this.selectedFiles.forEach((file, index) => {
                formData.append(`referenceImages[${index}]`, file);
            });

            formData.append('customer_from', String(this.customerFrom));
            formData.append('customer_id', String(this.currentUser?.customers_id || ''));


            this.apiService.addAiEnquiry(formData).subscribe(data => {
                this.toastService.success('Contact Saved successfully');
                this.form.reset();
            }, err => {
                this.toastService.error('There is some issue. Please react us directly on 8448997281');
            });
        } else {
            this.form.markAllAsTouched();
        }
    }

    onReferenceImageChange(event: Event): void {
        const input = event.target as HTMLInputElement;
        if (input.files && input.files.length > 0) {
            const file = input.files[0];
            this.form.get('referenceImage')?.setValue(file);
        }
    }


    getFormControl(control: any): FormControl {
        return control as FormControl;
    }

    aspectRatios = [
        {
            id: 1,
            name: '1:1',
            slug: '1:1',
            image: 'assets/images/ai/filter-icon/1-1.jpg',
        },
        {
            id: 2,
            name: '2:3',
            slug: '2:3',
            image: 'assets/images/ai/filter-icon/2-3.jpg'
        },
        {
            id: 3,
            name: '3:2',
            slug: '3:2',
            image: 'assets/images/ai/filter-icon/3-2.jpg'
        },
        {
            id: 4,
            name: '3:4',
            slug: '3:4',
            image: 'assets/images/ai/filter-icon/3-4.jpg'
        },
        {
            id: 5,
            name: '4:3',
            slug: '4:3',
            image: 'assets/images/ai/filter-icon/4-3.jpg'
        },
        {
            id: 6,
            name: '4:5',
            slug: '4:5',
            image: 'assets/images/ai/filter-icon/4-5.jpg'
        },
        {
            id: 7,
            name: '5:4',
            slug: '5:4',
            image: 'assets/images/ai/filter-icon/5-4.jpg'
        },
        {
            id: 9,
            name: '16:9',
            slug: '16:9',
            image: 'assets/images/ai/filter-icon/16-9.jpg'
        }
    ];

    styles = [
        {
            id: 1,
            name: 'Auto',
            slug: 'auto',
            image: 'assets/images/ai/filter-icon/auto.jpg',
        },
        {
            id: 2,
            name: 'Art',
            slug: 'art',
            image: 'assets/images/ai/filter-icon/art.jpg'
        },
        {
            id: 3,
            name: 'Photography',
            slug: 'photography',
            image: 'assets/images/ai/filter-icon/photography.jpg'
        },
    ];


    onGenerateImage() {
        // console.log('Generate image clicked: ', this.currentUser);
        this.generateButtonClick = true;
        this.loaded = false;
        this.productLoaded = false;

        if (!this.currentUser) {
            this.loaded = true;
            // this.modalService.showLoginModal();
            this.toastService.error('Please purchase a plan to enable AI image creation.');
            this.router.navigate(['/subscription']);
            this.generateButtonClick = false;
            return;
        }

        if(this.currentUser.isExclusive == true){
        // if (!this.guardImageGeneration()) {
        //     this.loaded = true;
        //     this.generateButtonClick = false;
        //     return;
        // }
    }

        const currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
        const planId = currentUser.plan_id;

        if (!planId && this.selectedModel != 'banana') {
            this.loaded = true;
            this.openPlanPopup();
            this.generateButtonClick = false;
            return;
        }

        if (this.selectedModel === 'banana') {
            this.generateImagesNanoBanana();
        } else if (this.selectedModel === 'nur_ai') {
            this.generateImagesDeposit();
        } else {
            this.generateImagesNanoBanana();
        }

        this.loadProducts();
    }

    protected readonly filterData = filterData;
    generatedImages: any[] = [];
    cols = 'col-6 col-md-4 col-lg-4 col-xl-3 col-xxl-2';
    type = 'images';
    params: any = [];
    previewArr = [];
    toggle = true;

    onAttrClick(attr: string, value: any) {
        if (attr === 'aspect_ratio') {
            this.selectedAspect = value.name;
            this.selectedAspectSlug = value.slug;
        }
        else if (attr === 'style') {
            this.selectedStyle = value;
        }
        this.closeAIAttributeCollapses();
    }

    generateImagesDeposit() {
        if (this.pollingInterval) {
            clearInterval(this.pollingInterval);
            this.pollingInterval = null;
        }

        this.status = 'Submitting...';
        this.generatedImages = [];

        const customerFrom = this.currentUser?.isExclusive === true ? 2 : 1;

        this.apiService.generateImage(this.promptText, this.selectedAspect, this.selectedStyle,this.currentUser.customers_id,customerFrom).subscribe({
            next: (res) => {
                this.uuid = res.data.uuid;
                this.status = 'Waiting for processing...';
                this.pollForResult();
            },
            error: (err) => {
                this.status = err.error.message;
                this.loaded = true;
                if (err.error?.message) {
                    this.toastService.error('We’re processing a lot of requests right now. Please try again shortly');
                    // this.toastService.error(err.error.message);
                    this.isPackageExpired = err.error.isPackageExpired;
                } else {
                    this.toastService.error('We’re processing a lot of requests right now. Please try again shortly');

                    // this.toastService.error('Problem in generating image, Contact sales to resolve issue');

                }

            }
        });
    }

    pollForResult() {
        let attempts = 0;

        // clear any previous interval if still running
        if (this.pollingInterval) {
            clearInterval(this.pollingInterval);
        }

        this.pollingInterval = setInterval(() => {
            attempts++;
            this.apiService.getAIImages(this.uuid).subscribe({
                next: (res) => {
                    this.status = res.status;

                    if (res.status === 'completed') {
                        this.generatedImages = res.items || [];
                        // console.log('line 428 this.generatedImages ', this.generatedImages);
                        this.loaded = true;
                        clearInterval(this.pollingInterval);
                        this.getRecentImagesGenerated();
                    }
                },
                error: (err) => {
                    this.status = `Sorry, we couldn't generated any matches for ${this.promptText}`;
                    this.loaded = true;
                    clearInterval(this.pollingInterval);
                }
            });

            // Stop after 10 attempts (10*5s = 50s)
            if (attempts >= 10) {
                clearInterval(this.pollingInterval);
                this.pollingInterval = null;
                this.status = 'Timeout: No result after 50s';
                this.loaded = true;
            }

        }, 8000);
    }

    loadProducts() {
        this.params['searchText'] = this.promptText;
        this.params['images'] = '15';
        this.params['page]'] = '1';
        let i = 0;
        this.apiService.fetchData(this.params, 15, this.type, this.currentUser ? this.currentUser.customers_id : '', this.currentUser ? false : true).pipe(takeUntil(this.destroy$)).subscribe(result => {
            this.products = result.results.map((obj) => {
                obj.category = 'creative',
                    this.previewArr.push({
                        src: obj.preview,
                        caption: (obj.caption ? obj.caption : '') + '<br/>' + 'Image ' + i++ + ' of ' + result.results.length,
                        thumb: obj.thumbnail
                    });
                return obj;
            });
            this.productLoaded = true;
        });
    }

    downloadCompImage(index: number) {
        const item = this.generatedImages[index];

        // NANO BANANA DOWNLOAD
        if (item.uuid.startsWith("banana-")) {

            if (!item.rawBase64) {
                console.error("Missing rawBase64 on item", item);
                return;
            }

            const blobUrl = this.base64ToBlobUrl(item.rawBase64);
            // const filename = "BANANA_" + item.uuid + ".png";
            const filename = "banana_" + Math.random().toString(36).substring(2, 15) + ".png";

            const a = document.createElement("a");
            a.href = blobUrl;
            a.download = filename;
            a.click();

            URL.revokeObjectURL(blobUrl);
            return;
        }

        // DEPOSIT DOWNLOAD (original untouched)
        const imageUrl = item.previewUrl;
        const filename = "IND_" + item.uuid;

        fetch(imageUrl, { mode: "cors" })
            .then(r => r.blob())
            .then(blob => {
                const url = URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = filename;
                a.click();
                URL.revokeObjectURL(url);
            })
            .catch(err => console.error("Download error:", err));
    }

    openImageSidebar(index, type, uuid, recentIndex) {
        // Reset sidebar state for each new image
        this.isPersonalUseChecked = false;
        this.isCommercialUseChecked = false;
        this.downloadButtonLabel = 'Select an option';

        this.selectedIndex = index;
        this.selectedRecentIndex = recentIndex;
        this.toggleSidebar();
        this.getSubscriptionDetail();

        // 1) HANDLE NANO BANANA
        // console.log('this.generatedImages[index] ', this.generatedImages, this.generatedImages[index])
        const item = this.generatedImages[index];

        if (item.model_type === 'nano-banana') {

            // Sidebar image display
            this.image = {
                title: "Nano Banana Generated Image",
                thumb_medium: item.previewUrl
            };

            // Deposit-compatible cartProduct
            this.cartProduct = {
                id: item.id,
                filename: item.uuid,
                thumbnail: item.previewUrl,
                license: 'Individual',
                collection: 232,
                size: type === 'comp' ? 'Large' : 'Extra Large',
                price: 0,
                type: 'AI',
                caption: item.prompt || "Nano Banana Image",
                category: 'creative',
                searchText: this.promptText,
                usage: this.usageSelected
            };

            return;
        }

        //  2) DEFAULT → EXISTING DEPOSIT LOGIC
        this.apiService.getAIImageDetail(uuid).subscribe({
            next: (res) => {
                this.image = res['data'];
                this.cartProduct = Object.assign({
                    id: this.image['id'],
                    filename: uuid,
                    thumbnail: this.image['thumb_medium'],
                    license: 'Individual',
                    collection: 232,
                    size: type == 'comp' ? 'Large' : 'Extra Large',
                    price: 0,
                    type: 'AI',
                    caption: this.image['title'],
                    category: 'creative',
                    searchText: this.promptText,
                    usage: this.usageSelected
                });
            },
            error: (err) => {
                this.toastService.error('Problem in getting image detail, Contact sales to resolve issue');
            }
        });

    }


    toggleSidebar() {
        if (document.querySelector('body').classList.contains('sidebar-filter-active')) {
            document.querySelector('body').classList.remove('sidebar-filter-active');
            if (!this.selectedEditImage) {
                this.selectedIndex = -1;
            }

            this.selectedRecentIndex = -1;

            // RESET CHECKBOXES & BUTTON LABEL
            this.isPersonalUseChecked = false;
            this.isCommercialUseChecked = false;
            this.downloadButtonLabel = 'Select an option';

        } else {
            document.querySelector('body').classList.add('sidebar-filter-active');
        }
    }

    hideSidebar() {
        this.toggleSidebar();
        // this.selectedIndex = -1;
        // console.log("hide sidebar");
        // document.querySelector('body').classList.remove('sidebar-filter-active');

    }

    public ackchk = false;

    chkboxEvent(checked: boolean) {
        this.ackchk = checked;
    }


    public getSubscriptionDetail() {
        if (this.currentUser && this.currentUser.isExclusive == false) {
            this.apiService.getSubscriptionDetailAI().subscribe(data => {
                this.btn = data['subscription'] > 0 ? 1 : 0;
            });
        }
    }

    onUsageChange($event: any) {
        this.usageSelected = $event.target.value;

    }

    download(index: number, type: string) {
        const item = this.generatedImages[index] ;
        // console.log('item ', item, this.generatedImages, index);

        if (item.model_type === 'nano-banana') {

            this.disableBtn = true;

            // send same structure as deposit
            const compPayload = { 
                ...this.cartProduct, 
                customer_from: this.customerFrom,
                customer_id: this.currentUser?.customers_id || '',
             };
            this.apiService.downloadNanoCompImage(compPayload, true).subscribe(data => {
                // console.log('downloadNanoCompImage data ', data)

                if(data && data.subscription == 0){
                    this.toastService.error('You’ve reached your usage limit. Please renew your plan to continue using this feature');
                    return;
                }
                this.disableBtn = false;

                const downloadUrl = data.download_link;
                const filename = this.cartProduct.filename + ".jpg";

                // direct download (NO fetch, NO CORS)
                const a = document.createElement("a");
                a.href = this.editedImageUrl || downloadUrl;
                a.setAttribute("download", filename);
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);

                this.toggleSidebar();
            },
                () => {
                    this.disableBtn = false;
                    this.toastService.error('We’re processing a lot of requests right now. Please try again shortly');
                    // this.toastService.error("Download failed");
                });

            return;
        }

        // DEPOSIT LOGIC (unchanged)
        this.disableBtn = true;
        const depositPayload = { 
            ...this.cartProduct, 
            customer_from: this.customerFrom,
            customer_id: this.currentUser?.customers_id || ''
        };
        this.apiService.downloadAIImage(depositPayload, true).subscribe(data => {
            
            this.disableBtn = false;
            let downloadUrl = data.download_link;
            if (type === "comp") {
                downloadUrl = this.selectedRecentIndex === -1
                    ? item.previewUrl
                    : this.recentHistory[this.selectedRecentIndex].items.data.items[this.selectedIndex].previewUrl;

                const filename = "IND_" + item.uuid;

                fetch(downloadUrl, { mode: "cors" })
                    .then(r => r.blob())
                    .then(blob => {
                        const url = URL.createObjectURL(blob);
                        const a = document.createElement("a");
                        a.href = url;
                        a.download = filename;
                        a.click();
                        URL.revokeObjectURL(url);
                    });
            } else {
                window.open(downloadUrl);
            }

            this.toggleSidebar();
        });
    }

    protected readonly event = event;

    changeSize($event: any) {
        $event.preventDefault();
    }

    getRecentImagesGenerated() {
        if (this.currentUser) {
            // this.apiService.getPromptHistoryRecent(this.currentUser?.customers_id).subscribe(data => {
            //   this.recentHistory = data;
            // });
        }
    }

    private resetAiPermissions(): void {
        this.aiPermissionsLoaded = false;
        this.aiPermissions = [];
        this.canGenerateImage = false;
        Object.keys(this.toolPermissions).forEach(k => this.toolPermissions[k] = false);
    }
    private showAllAiPermissions(): void {
        this.aiPermissionsLoaded = false;
        this.aiPermissions = [];
        this.canGenerateImage = false;
        Object.keys(this.toolPermissions).forEach(k => this.toolPermissions[k] = true);
    }

    loadAiPermissions(): void {
        const customerId = (this.currentUser as any)?.customers_id;
        if (!customerId) { this.resetAiPermissions(); return; }
        this.apiService.getCustomerAiPermission(customerId).subscribe(
            (res: any) => {
                const records = Array.isArray(res?.data) ? res.data : [];
                this.aiPermissions = records;
                this.computeAiPermissions(records);
                this.aiPermissionsLoaded = true;
            },
            () => { this.aiPermissionsLoaded = true; }
        );
    }

    private computeAiPermissions(records: any[]): void {
        const norm = (s: any) => String(s || '')
            .toLowerCase().trim()
            .replace(/[\s\-]+/g, '_')
            .replace(/[^a-z0-9_]/g, '');

        const allowsImage = records.some((r: any) =>
            (r.ai_media_types || []).some((m: any) => String(m?.id).toLowerCase() == 'image')
        );
        const hasImagePromptQuota = records.some((r: any) => Number(r.total_ai_image_prompt) > 0);
        // this.canGenerateImage = allowsImage && hasImagePromptQuota;
         this.canGenerateImage =  hasImagePromptQuota;

        // console.log('AI Permissions: ', this.canGenerateImage, allowsImage, hasImagePromptQuota, records);

        const allowed = new Set<string>();
        records.forEach((r: any) => {
            (r.ai_tools || []).forEach((t: any) => allowed.add(norm(t?.name)));
        });
        Object.keys(this.toolPermissions).forEach(key => {
            this.toolPermissions[key] = allowed.has(key);
        });
    }

    private guardImageGeneration(): boolean {
        if (!this.aiPermissionsLoaded) {
            this.toastService.error('Checking permissions, please try again in a moment.');
            return false;
        }
        if (!this.canGenerateImage) {
            this.toastService.error('You do not have permission to generate AI images. Please contact your administrator.');
            return false;
        }
        return true;
    }

    private guardTool(toolKey: string): boolean {
        if (!this.aiPermissionsLoaded) {
            this.toastService.error('Checking permissions, please try again in a moment.');
            return false;
        }
        if (!this.toolPermissions[toolKey]) {
            const label = this.toolLabels[toolKey] || toolKey;
            this.toastService.error(`You do not have permission to use ${label}. Please contact your administrator.`);
            return false;
        }
        return true;
    }


    //Sidar Ai image downloading Process

    onPersonalUseChange(checked: boolean) {
        this.isPersonalUseChecked = checked;
        this.updateDownloadButtonLabel();
    }

    onCommercialUseChange(checked: boolean) {
        this.isCommercialUseChecked = checked;
        this.updateDownloadButtonLabel();
    }


    updateDownloadButtonLabel() {
        if (this.isPersonalUseChecked && this.isCommercialUseChecked) {
            this.downloadButtonLabel = 'Comp Download & Request for Approval';
        } else if (this.isPersonalUseChecked) {
            this.downloadButtonLabel = 'Comp Download';
        } else if (this.isCommercialUseChecked) {
            this.downloadButtonLabel = 'Request for Approval';
        } else {
            this.downloadButtonLabel = 'Select an option';
        }
    }

    handleAIDownload() {
        if (!this.isPersonalUseChecked && !this.isCommercialUseChecked) {
            this.toastService.error('Please select at least one option.');
            return;
        }

        const item = this.generatedImages[this.selectedIndex];
        // console.log('this.generatedImages[this.selectedIndex] 123 ' ,this.selectedIndex , this.generatedImages , this.generatedImages[this.selectedIndex]);

        const aiModel = item.model_type === 'nano-banana'
            ? 'BANANA_AI'
            : 'NUR_AI';

        this.checkLicenseBeforeDownload(aiModel, () => {
            this.sendLicenseRequest();
            // this.download(this.selectedIndex, 'comp');
            // CASE 1: Only Personal Use
            // if (this.isPersonalUseChecked && !this.isCommercialUseChecked) {
            //     console.log('download 1 ', this.selectedIndex);
            //     this.download(this.selectedIndex, 'comp');
            //     return;
            // }

            // CASE 2: Only Commercial Use
            // if (!this.isPersonalUseChecked && this.isCommercialUseChecked) {
            //     this.sendLicenseRequest();
            //     return;
            // }

            // CASE 3: Both
            // if (this.isPersonalUseChecked && this.isCommercialUseChecked) {
            //     this.sendLicenseRequest();
            //     setTimeout(() => {
            //         console.log('download 2 ', this.selectedIndex);
            //         this.download(this.selectedIndex, 'comp');
            //     }, 4000);
            // }
        });
    }


    sendLicenseRequest() {
        const item = this.generatedImages[this.selectedIndex];

        if (item.model_type === 'nano-banana') {

            this.disableBtn = true;

            if(this.editedImage){
            var params = {
                ...this.cartProduct, 
                filename: this.editedImage?.uuid, 
                customer_from: this.customerFrom,
                customer_id: this.currentUser?.customers_id || '',
            };
            }else{
            var params = {
                ...this.cartProduct, 
                customer_from: this.customerFrom,
                customer_id: this.currentUser?.customers_id || '',
            };
            }
            // send same structure as deposit
            this.apiService.downloadNanoHighResImage(params, true).subscribe(data => {
                

                if(data && data.subscription == 0){
                    this.toastService.error('You’ve reached your usage limit. Please renew your plan to continue using this feature');
                    return;
                }
                this.disableBtn = false;

                const downloadUrl = data.download_link;
                const filename = this.cartProduct.filename + ".jpg";

                // direct download (NO fetch, NO CORS)
                const a = document.createElement("a");
                a.href = downloadUrl;
                a.setAttribute("download", filename);
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);

                // this.toggleSidebar();
            },
                () => {
                    this.disableBtn = false;
                    this.toastService.error('We’re processing a lot of requests right now. Please try again shortly');
                    // this.toastService.error("Download failed");
                });

            return;
        }

        // DEFAULT → EXISTING DEPOSIT LOGIC
        const currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');

        const payload = {
            jobUuid: this.uuid,
            imageUuid: item.uuid,
            customers_email_address: currentUser.customers_email_address,
            collection: this.cartProduct.collection,
            category: this.cartProduct.category,
            size: this.cartProduct.size,
            caption: this.cartProduct.caption,
            usage: this.cartProduct.usage,
            customers_company: currentUser.customers_company,
            customer_name: `${currentUser.customers_firstname} ${currentUser.customers_lastname}`,
            customer_from: this.customerFrom,
            customer_id: currentUser.customers_id
        };


        this.apiService.requestLicenseAIImage(payload).subscribe({
            next: (res) => {
                this.toastService.success('License request submitted successfully for approval.');
                
            },
            error: (err) => {
                this.toastService.error('We’re processing a lot of requests right now. Please try again shortly');
                // this.toastService.error('Error sending license request');
                console.error(err);
            }
        });
    }


    showLicense = false;

    openLicenseModal() {
        if (this.selectedModel === 'banana') {
            this.currentEulaHtml = EULA_NANO;
        } else {
            this.currentEulaHtml = EULA_NUR;
        }
        this.showLicense = true;
    }

    closeLicenseModal() {
        this.showLicense = false;
    }

    openExternalLink(path: string) {
        window.open(`/${path}`, "_blank");
    }




    base64ToBlobUrl(base64: string): string {

        // Case 1: backend returned only raw base64
        if (!base64.startsWith('data:')) {
            base64 = 'data:image/png;base64,' + base64;
        }

        const parts = base64.split(',');
        if (parts.length < 2) {
            console.error("Invalid base64 format", base64);
            return '';
        }

        const mimeMatch = parts[0].match(/:(.*?);/);
        const mime = mimeMatch ? mimeMatch[1] : 'image/png';

        const binary = atob(parts[1]);
        let length = binary.length;
        const buffer = new Uint8Array(length);

        while (length--) {
            buffer[length] = binary.charCodeAt(length);
        }

        const blob = new Blob([buffer], { type: mime });
        return URL.createObjectURL(blob);
    }


    generateImagesNanoBanana() {
        this.status = 'Submitting...';
        this.generatedImages = [];
        this.loaded = false;

        const formData = new FormData();
        formData.append('prompt', this.promptText);
        formData.append('aspect_ratio', this.selectedAspect);
        formData.append('style', this.selectedStyle);
        formData.append('customer_from', String(this.customerFrom));
        formData.append('customer_id', String(this.currentUser?.customers_id || ''));


        // ⭐ THIS IS THE IMPORTANT PART
        if (this.attachedImage) {
            formData.append('image_reference', this.attachedImage);
        }

        // console.log(this.attachedImage);
        // console.log(this.attachedImage instanceof File);

        this.apiService.generateNanoBanana(formData)
            .subscribe({
                next: (res) => {

                    if (!res.images || res.images.length === 0) {
                        this.status = "No images returned from Nano Banana.";
                        this.loaded = true;
                        return;
                    }

                    this.generatedImages = res.images.map((img: any) => ({
                        id: img.id || img.image_id,
                        uuid: img.uuid,
                        previewUrl: img.image_url,
                        model_type: 'nano-banana',
                        status: img.status ?? 'generated',
                        aspect_ratio: this.selectedAspect,
                        style: this.selectedStyle
                    }));

                    this.loaded = true;
                    this.status = "completed";
                },
                error: (err) => {
                    // console.log(err)
                    if(err?.error?.isPackageExpired && err?.error?.isPackageExpired == true){
                        this.toastService.error(
                    'You’ve reached your usage limit. Please renew your plan to continue using this feature');
                    }else{
                        this.toastService.error(err.error?.errors?.image_reference[0] ?? 
                        'We’re processing a lot of requests right now. Please try again shortly and Only JPG and PNG images are supported.');
                    }
                    
                    this.loaded = true;
                    // this.toastService.error(this.status);
                }
            });
    }


    onModelSelect(model: string) {
        const selected = this.models.find(m => m.value === model);

        this.selectedModel = model;
        this.selectedModelLabel = selected?.label || model;

        // close other dropdowns
        this.closeAIAttributeCollapses();
    }


    closeAIAttributeCollapses() {
        const openCollapses = document.querySelectorAll('#ai-filter .collapse.show');

        openCollapses.forEach((el: any) => {
            el.classList.remove('show');

            // also reset aria-expanded on trigger
            const trigger = document.querySelector(`[href="#${el.id}"]`);
            trigger?.setAttribute('aria-expanded', 'false');
            trigger?.classList.add('collapsed');
        });
    }


    // Plan purchase pop up
    openPlanPopup() {
        this.showPlanPopup = true;
    }

    closePlanPopup() {
        this.showPlanPopup = false;
    }

    goToSubscription() {
        this.showPlanPopup = false;
        window.location.href = '/subscription';
    }


    private checkLicenseBeforeDownload(aiModel: 'BANANA_AI' | 'NUR_AI',
        proceed: () => void) {
        this.aiStatusService.getStatus(aiModel).subscribe({
            next: (res) => {

                // License already accepted once → never show modal again
                if (res?.status === 1) {
                    proceed();
                    return;
                }

                // License NOT accepted → MUST decide
                this.modalService.showAiLicenseModal(aiModel)
                    .then((result) => {
                        // ACCEPT = permanent acceptance
                        if (result === 'ACCEPTED') {
                            this.aiStatusService.accept(aiModel).subscribe(() => {
                                proceed();
                            });
                            return;
                        }

                        // REJECT = allow this action only
                        if (result === 'REJECTED') {
                            this.aiStatusService.reject(aiModel).subscribe(() => {
                                this.toastService.warning(
                                    'Proceeding without license. Usage is at your own risk.'
                                );
                                proceed();
                            });
                            return;
                        }

                    });

            },

            // Even if status API fails, still enforce decision
            error: () => {
                this.modalService.showAiLicenseModal(aiModel)
                    .then((result) => {

                        if (result === 'ACCEPTED') {
                            proceed();
                            return;
                        }

                        if (result === 'REJECTED') {
                            this.toastService.warning(
                                'Proceeding without license. Usage is at your own risk.'
                            );
                            proceed();
                            return;
                        }

                    });
            }
        });
    }


    showUploadModal = false;
    selectedFile: File | null = null;
    previewImage: string | ArrayBuffer | null = null;

    openUploadModal() {
        this.showUploadModal = true;
    }

    closeUploadModal() {
        this.showUploadModal = false;
        this.selectedFile = null;
    }


    submitUploadedImage() {

        if (!this.selectedFile) return;
        this.attachedImage = this.selectedFile;
        this.showUploadModal = false;
        this.selectedFile = null;
    }


    onDragOver(event: DragEvent) {
        event.preventDefault();
    }

    onDrop(event: DragEvent) {
        event.preventDefault();

        if (event.dataTransfer?.files.length) {
            const file = event.dataTransfer.files[0];
            this.processFile(file);
        }
    }

    onFileSelected(event: any) {
        const file = event.target.files[0];
        if (file) {
            this.processFile(file);
        }
    }

    processFile(file: File) {
        this.selectedFile = file;

        const reader = new FileReader();
        reader.onload = () => {
            this.previewImage = reader.result;
        };
        reader.readAsDataURL(file);
    }

    removeImage(event: Event) {
        event.stopPropagation();
        this.selectedFile = null;
        this.previewImage = null;
    }








    //Edit fucnitonlity

    isEditMode = false;
    selectedEditImage: any = null;
    editedImageUrl: string | null = null;
    isEditingLoading = false;


    openEditPanel(image: any, index: number) {
        this.selectedIndex = index;
        this.selectedEditImage = image;
        this.editedImageUrl = null;
        this.isEditMode = true;

        document.body.classList.add('edit-panel-active');
    }

    // Add this property to your component class
    progressPercentage: number = 0;
    private progressInterval: any;
    selectedTool: string = '';           // Track which tool is currently active
    lastAppliedTool: string = '';        // Track last successfully applied tool



    // editingToolApply(tool: string) {
    //     if (!this.selectedEditImage) return;

    //     this.isEditingLoading = true;
    //     this.progressPercentage = 0;

    //     // Start progress simulation
    //     this.startProgressSimulation();

    //     this.apiService.editingTool(this.selectedEditImage.uuid, tool)
    //         .subscribe({
    //         next: (res) => {

    //             if (!res.success) {
    //                 this.toastService.error("Editing failed.");
    //                 this.isEditingLoading = false;
    //                 this.progressPercentage = 0;
    //                 this.clearProgressInterval();
    //                 return;
    //             }

    //             // ONLY show edited preview inside edit panel
    //             this.editedImageUrl = res.image_url;
    //             this.progressPercentage = 100;

    //             // REMOVED: Do NOT add edited image to gallery
    //             // this.generatedImages.unshift({...});

    //             // Small delay to show 100% then reset
    //             setTimeout(() => {
    //                 this.isEditingLoading = false;
    //                 this.progressPercentage = 0;
    //                 this.clearProgressInterval();
    //             }, 500);
    //         },
    //         error: (err) => {
    //             this.toastService.error(err.error?.message || "Editing failed.");
    //             this.isEditingLoading = false;
    //             this.progressPercentage = 0;
    //             this.clearProgressInterval();
    //         }
    //     });
    // }


    // New method to start progress simulation
    // private startProgressSimulation() {
    //     this.progressPercentage = 0;
    //     this.clearProgressInterval(); // Clear any existing interval

    //     this.progressInterval = setInterval(() => {
    //         if (this.isEditingLoading && this.progressPercentage < 90) {
    //         // Slow down as it progresses
    //         const increment = this.progressPercentage < 30 ? 15 : 
    //                         this.progressPercentage < 60 ? 10 : 5;
    //         this.progressPercentage = Math.min(this.progressPercentage + increment, 90);
    //         }
    //     }, 400);
    // }


    editingToolApply(tool: string) {
        if (!this.selectedEditImage) return;
        if(this.currentUser.isExclusive == true){
            // if (!this.guardTool(tool)) return;
        }

        // Set the current tool
        this.selectedTool = tool;
        this.isEditingLoading = true;
        this.progressPercentage = 0;
        this.isObjectRemovalMode = false;

        // Start progress simulation
        this.startProgressSimulation();

        this.apiService.editingTool(this.selectedEditImage.uuid, tool, "", "", this.currentUser?.customers_id, this.customerFrom)
            .subscribe({
                next: (res) => {

                    if (!res.success) {
                        this.toastService.error("We’re processing a lot of requests right now. Please try again shortly.");
                        this.isEditingLoading = false;
                        this.progressPercentage = 0;
                        this.selectedTool = '';
                        this.clearProgressInterval();
                        return;
                    }

                    // ONLY show edited preview inside edit panel
                    this.editedImage = null;
                    this.editedImageUrl = res.image_url;
                    this.editedImage = res;
                    this.progressPercentage = 100;

                    // Set last applied tool for completion status
                    this.lastAppliedTool = tool;

                    // REMOVED: Do NOT add edited image to gallery
                    // this.generatedImages.unshift({...});

                    // Small delay to show 100% then reset
                    setTimeout(() => {
                        this.isEditingLoading = false;
                        this.progressPercentage = 0;
                        this.selectedTool = '';  // Clear active tool
                        this.clearProgressInterval();
                    }, 500);
                },
                error: (err) => {
                    if(err?.error?.isPackageExpired && err?.error?.isPackageExpired == true){
                        this.toastService.error(
                    'You’ve reached your usage limit. Please renew your plan to continue using this feature');
                    }else{
                        this.toastService.error(err.error?.errors?.image_reference[0] ?? 
                        'We’re processing a lot of requests right now. Please try again shortly and Only JPG and PNG images are supported.');
                    }
                    this.isEditingLoading = false;
                    this.progressPercentage = 0;
                    this.selectedTool = '';      // Clear active tool on error
                    this.clearProgressInterval();
                }
            });
    }

    // New method to start progress simulation
    private startProgressSimulation() {
        this.progressPercentage = 0;
        this.clearProgressInterval(); // Clear any existing interval

        this.progressInterval = setInterval(() => {
            if (this.isEditingLoading && this.progressPercentage < 90) {
                // Slow down as it progresses
                const increment = this.progressPercentage < 30 ? 15 :
                    this.progressPercentage < 60 ? 10 : 5;
                this.progressPercentage = Math.min(this.progressPercentage + increment, 90);
            }
        }, 400);
    }

    // New method to clear interval
    private clearProgressInterval() {
        if (this.progressInterval) {
            clearInterval(this.progressInterval);
            this.progressInterval = null;
        }
    }

    // Update your closeEditPanel method
    closeEditPanel() {
        this.isEditMode = false;
        this.isEditingLoading = false;
        this.progressPercentage = 0;
        this.selectedTool = '';           // Clear selected tool
        this.lastAppliedTool = '';        // Clear last applied tool
        this.clearProgressInterval();
        this.selectedEditImage = null;
        this.editedImageUrl = null;
        this.editedImage = null;
        document.body.classList.remove('edit-panel-active');
        
    }

    // // New method to clear interval
    // private clearProgressInterval() {
    // if (this.progressInterval) {
    //     clearInterval(this.progressInterval);
    //     this.progressInterval = null;
    // }
    // }


    // // Update your closeEditPanel method
    // closeEditPanel() {
    //     this.isEditMode = false;
    //     this.isEditingLoading = false;
    //     this.progressPercentage = 0;
    //     this.clearProgressInterval();
    //     this.selectedEditImage = null;
    //     this.editedImageUrl = null;
    //     document.body.classList.remove('edit-panel-active');
    // }

    // Also add this to your ngOnInit or constructor for cleanup
    ngOnDestroy() {
        this.clearProgressInterval();
        this.destroy$.next();
        this.destroy$.complete();
    }


    removeAttachedImage() {
        this.attachedImage = null;
        this.previewImage = null;
    }


    downloadEditedImage() {
        if (!this.editedImageUrl) return;

        const a = document.createElement("a");
        a.href = this.editedImageUrl;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }


    activateObjectRemoval() {
        if (!this.selectedEditImage) return;
        if(this.currentUser.isExclusive == true){
            // if (!this.guardTool('semantic_masking')) return;
        }
        this.isObjectRemovalMode = true;

        setTimeout(() => {
            this.initializeCanvas();
        }, 100);
    }

    private initializeCanvas() {
        const canvas = this.maskCanvasRef?.nativeElement;
        if (!canvas) return;

        const imageElement = document.querySelector('.preview-image') as HTMLImageElement;
        if (!imageElement) return;

        canvas.width = imageElement.clientWidth;
        canvas.height = imageElement.clientHeight;

        this.ctx = canvas.getContext('2d')!;
        this.ctx.clearRect(0, 0, canvas.width, canvas.height);

        canvas.addEventListener('mousedown', this.startDrawing.bind(this));
        canvas.addEventListener('mousemove', this.draw.bind(this));
        canvas.addEventListener('mouseup', this.stopDrawing.bind(this));
        canvas.addEventListener('mouseleave', this.stopDrawing.bind(this));
    }


    private startDrawing(event: MouseEvent) {
        this.drawing = true;
        this.draw(event);
    }

    private draw(event: MouseEvent) {
        if (!this.drawing) return;

        const rect = this.maskCanvasRef.nativeElement.getBoundingClientRect();
        const x = event.clientX - rect.left;
        const y = event.clientY - rect.top;

        this.ctx.fillStyle = 'white';
        this.ctx.beginPath();
        this.ctx.arc(x, y, this.brushSize, 0, Math.PI * 2);
        this.ctx.fill();
    }

    private stopDrawing() {
        this.drawing = false;
    }

    clearMask() {
        const canvas = this.maskCanvasRef?.nativeElement;
        if (!canvas) return;

        this.ctx.clearRect(0, 0, canvas.width, canvas.height);
    }

    applyObjectRemoval(tool: string) {

        if (!this.selectedEditImage) return;
        if(this.currentUser.isExclusive == true){
            // if (!this.guardTool(tool)) return;
        }

        // Set the current tool
        this.selectedTool = tool;
        this.isEditingLoading = true;
        this.progressPercentage = 0;
        this.isObjectRemovalMode = false;

        // Start progress simulation
        this.startProgressSimulation();

        this.apiService.editingTool(this.selectedEditImage.uuid, tool, "", "", this.currentUser?.customers_id, this.customerFrom)
            .subscribe({
                next: (res) => {

                    if (!res.success) {
                        this.toastService.error('We’re processing a lot of requests right now. Please try again shortly');
                        // this.toastService.error("Editing failed.");
                        this.isEditingLoading = false;
                        this.progressPercentage = 0;
                        this.selectedTool = '';
                        this.clearProgressInterval();
                        return;
                    }

                    // ONLY show edited preview inside edit panel
                    this.editedImage = null;
                    this.editedImageUrl = res.image_url;
                    this.editedImage = res;
                    this.progressPercentage = 100;

                    // Set last applied tool for completion status
                    this.lastAppliedTool = tool;

                    // REMOVED: Do NOT add edited image to gallery
                    // this.generatedImages.unshift({...});

                    // Small delay to show 100% then reset
                    setTimeout(() => {
                        this.isEditingLoading = false;
                        this.progressPercentage = 0;
                        this.selectedTool = '';  // Clear active tool
                        this.clearProgressInterval();
                    }, 500);
                },
                error: (err) => {
                    this.toastService.error('We’re processing a lot of requests right now. Please try again shortly');
                    // this.toastService.error(err.error?.message || "Editing failed.");
                    this.isEditingLoading = false;
                    this.progressPercentage = 0;
                    this.selectedTool = '';      // Clear active tool on error
                    this.clearProgressInterval();
                }
            });


        // if (!this.maskCanvasRef) return;

        // const canvas = this.maskCanvasRef.nativeElement;
        // const maskBase64 = canvas.toDataURL('image/png').split(',')[1];

        // this.isObjectRemovalMode = false;

        // this.selectedTool = 'object_removal';
        // this.isEditingLoading = true;
        // this.progressPercentage = 0;

        // this.startProgressSimulation();

        // this.apiService.editingTool(
        //     this.selectedEditImage.uuid,
        //     'object_removal',
        //     maskBase64
        // ).subscribe({
        //     next: (res) => {
        //         if (!res.success) {
        //             this.toastService.error("Object removal failed.");
        //             this.isEditingLoading = false;
        //             this.clearProgressInterval();
        //             return;
        //         }

        //         this.editedImageUrl = res.image_url;
        //         this.progressPercentage = 100;
        //         this.lastAppliedTool = 'object_removal';

        //         setTimeout(() => {
        //             this.isEditingLoading = false;
        //             this.progressPercentage = 0;
        //             this.selectedTool = '';
        //             this.clearProgressInterval();
        //         }, 500);
        //     },
        //     error: (err) => {
        //         this.toastService.error(err.error?.message || "Object removal failed.");
        //         this.isEditingLoading = false;
        //         this.clearProgressInterval();
        //     }
        // });
    }

    applySemanticMasking(tool: string, prompt = "") {

        if (!this.selectedEditImage) return;
        if(this.currentUser.isExclusive == true){
            // if (!this.guardTool(tool)) return;
        }

        if (tool == 'semantic_masking' && prompt == '') {
            this.toastService.error('Please write semantic masking instruction.');
            return;
        }

        // Set the current tool
        this.selectedTool = tool;
        this.isEditingLoading = true;
        this.progressPercentage = 0;

        // Start progress simulation
        this.startProgressSimulation();

        this.apiService.editingTool(this.selectedEditImage.uuid, tool, "", prompt, this.currentUser?.customers_id, this.customerFrom)
            .subscribe({
                next: (res) => {

                    if (!res.success) {
                        this.toastService.error('We’re processing a lot of requests right now. Please try again shortly');
                        // this.toastService.error("Editing failed.");
                        this.isEditingLoading = false;
                        this.progressPercentage = 0;
                        this.selectedTool = '';
                        this.clearProgressInterval();
                        return;
                    }

                    // ONLY show edited preview inside edit panel
                    this.editedImage = null;
                    this.editedImageUrl = res.image_url;
                    this.editedImage = res;
                    this.progressPercentage = 100;

                    // Set last applied tool for completion status
                    this.lastAppliedTool = tool;

                    // REMOVED: Do NOT add edited image to gallery
                    // this.generatedImages.unshift({...});

                    // Small delay to show 100% then reset
                    setTimeout(() => {
                        this.isEditingLoading = false;
                        this.progressPercentage = 0;
                        this.selectedTool = '';  // Clear active tool
                        this.clearProgressInterval();
                    }, 500);
                },
                error: (err) => {
                        this.toastService.error('We’re processing a lot of requests right now. Please try again shortly');
                    // this.toastService.error(err.error?.message || "Editing failed.");
                    this.isEditingLoading = false;
                    this.progressPercentage = 0;
                    this.selectedTool = '';      // Clear active tool on error
                    this.clearProgressInterval();
                }
            });
    }

    // editingTool(uuid: string, tool: string, maskBase64?: string) {
    //     return this.http.post<any>(`${this.apiUrl}/edit`, {
    //         image_uuid: uuid,
    //         tool: tool,
    //         mask_base64: maskBase64 || null
    //     });
    // }

    onZoom(event: WheelEvent) {

        event.preventDefault();

        const zoomSpeed = 0.1;

        if (event.deltaY < 0) {
            this.scale += zoomSpeed;
        } else {
            this.scale -= zoomSpeed;
        }

        this.scale = Math.max(this.minScale, Math.min(this.maxScale, this.scale));

    }

    startDrag(event: MouseEvent) {
        if (this.scale === 1) return;

        this.isDragging = true;
        this.startX = event.clientX - this.posX;
        this.startY = event.clientY - this.posY;
    }

    onDrag(event: MouseEvent) {
        if (!this.isDragging) return;

        this.posX = event.clientX - this.startX;
        this.posY = event.clientY - this.startY;
    }

    endDrag() {
        this.isDragging = false;
    }

    resetImagePosition() {
        this.posX = 0;
        this.posY = 0;
        this.startX = 0;
        this.startY = 0;
        this.scale = 1;
    }

    // Upscale Image
    upscaleFile: File | null = null;
    upscalePreviewUrl: string | null = null;
    isUpscaleDragOver = false;

    onUpscaleDragOver(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
        this.isUpscaleDragOver = true;
    }

    onUpscaleDragLeave(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
        this.isUpscaleDragOver = false;
    }

    onUpscaleDrop(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
        this.isUpscaleDragOver = false;

        const files = event.dataTransfer?.files;
        if (files && files.length > 0) {
            this.handleUpscaleFile(files[0]);
        }
    }

    onUpscaleFileSelected(event: Event) {
        const input = event.target as HTMLInputElement;
        if (input.files && input.files.length > 0) {
            this.handleUpscaleFile(input.files[0]);
            input.value = '';
        }
    }

    private handleUpscaleFile(file: File) {
        const validTypes = ['image/jpeg', 'image/png', 'image/webp'];
        if (!validTypes.includes(file.type)) {
            this.toastService.error('Only JPG,PNG and WEBP images are supported. Please upload a valid file format');
            return;
        }
        this.upscaleFile = file;
        const reader = new FileReader();
        reader.onload = (e: any) => {
            this.upscalePreviewUrl = e.target.result;
        };
        reader.readAsDataURL(file);
    }

    removeUpscaleImage() {
        this.upscaleFile = null;
        this.upscalePreviewUrl = null;
    }

    upscaleImage(tool: string) {
        

        if (!this.currentUser) {
            this.loaded = true;
            // this.modalService.showLoginModal();
            this.toastService.error('Please purchase a plan to enable AI image creation');
            this.router.navigate(['/subscription']);
            return;
        }

        if (!this.upscaleFile) {
            this.toastService.error('No image selected for upscaling.');
            return;
        }

        const formData = new FormData();
        formData.append('image', this.upscaleFile);
        formData.append('tool', tool);
        formData.append('customer_from', String(this.customerFrom));
        formData.append('customer_id', String(this.currentUser?.customers_id || ''));

        this.apiService.upscaleImage(formData).subscribe({
            next: (res) => {
                this.toastService.success('Image upscaled successfully!');
                
                 const a = document.createElement("a");
                a.href =res.image_url;
                a.setAttribute("download", 'upsacaled_image.jpg');
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            },error: (err) => {
                if(err?.error?.isPackageExpired && err?.error?.isPackageExpired == true){
                        this.toastService.error(
                    'You’ve reached your usage limit. Please renew your plan to continue using this feature');
                    }else{
                        this.toastService.error(err.error?.errors?.image_reference[0] ?? 
                        'We’re processing a lot of requests right now. Please try again shortly and Only JPG and PNG images are supported.');
                    }
            }
        });
    }
}
